interface Props {
    haEnabled: boolean
    numNodes: number
    numMySqlBackups: number
    numImages: number
    imageSize: number
    loggingEnabled: boolean
    mySqlLocal: boolean
}

function CalculationTable({haEnabled, numNodes, numMySqlBackups, numImages, imageSize, loggingEnabled, mySqlLocal}: Props){
    
    // Elastic wants 100GB per 5,000 VMs without logging
    // Elastic wants 200GB per 5,000 VMs with logging
    let elasticSize = numNodes/5000*100
    if(loggingEnabled){
        elasticSize = numNodes/5000*200
    }
    
    // RabbitMQ wants 20GB per 5,000 VMs
    let rabbitSize = numNodes/5000*20

    // MySQL wants .4GB (400MB) per 5,000 VMs
    let mySqlSize = numNodes/5000*.4
    if(mySqlSize < .4){
        mySqlSize = .4
    }

    let mySqlBackupsSize = 0
    if(mySqlLocal){
        mySqlBackupsSize = numMySqlBackups*mySqlSize
    }

    let uploadSize = numImages*imageSize
    
    // /var/opt/morpheus/morpheus-ui calculation
    let varOptMorpheusMorpheusUiSize = uploadSize + 50
    
    // /var/opt/morpheus calculation
    let varOptMorpheusSize = elasticSize + rabbitSize + mySqlSize + mySqlBackupsSize + 20
    if(varOptMorpheusSize < 100){
        varOptMorpheusSize = 100
    }
    if(!haEnabled){
        varOptMorpheusSize += varOptMorpheusMorpheusUiSize
    }

    // values rouneded up
    let rows = new Array
    rows.push(
        {
            path: '/opt/morpheus',
            size: '30GB'
        },
        {
            path: '/var/opt/morpheus',
            size: `${Math.ceil(varOptMorpheusSize)}GB`
        }
    )

    if(haEnabled){
        rows.push(
            {
                path: '/var/opt/morpheus/morpheus-ui',
                size: `${Math.ceil(varOptMorpheusMorpheusUiSize)}GB`
            }
        )
    }

    rows.push(
        {
            path: '/home',
            size: '20GB'
        },
        {
            path: '/var/log',
            size: '20GB'
        },
        {
            path: '/tmp',
            size: '20GB'
        }
    )

    return (
        <div className="row mt-2">
            <table className="table table-dark table-striped">
                <thead>
                    <tr>
                        <td>Size</td>
                        <td>Mount Point</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.map((item,index) => 
                            <tr>
                                <td width="127">{item.size}</td>
                                <td>{item.path}</td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}

export default CalculationTable;